<template>
  <span class="X">
    <!-- slot for parent component to activate the file changer -->
    <span @click="launchFilePicker()">
      <slot name="activator" />
    </span>

    <!-- image input: style is set to hidden and assigned a ref so that it can be triggered -->
    <input 
      ref="file"
      v-validate="extensionRule"
      :name="fieldName"
      :accept="acceptType"
      :multiple="multiple"
      type="file"      
      class="d-none"
      @change="onFileChange($event.target.name, $event.target.files)"      
    >

    <!-- error dialog displays any potential error messages -->
    <v-dialog 
      v-model="errorDialog" 
      max-width="300"
    >
      <v-card class="pt-4">
        <v-card-text> {{ errorText }} </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn 
            text
            @click="errorDialog = false"
          > 
            Got it!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      // Use "value" to enable using v-model
      value: {
        type: Object,
        default: null,
      },
      maxSizeInMb: {
        type: Number,
        required: true,
      },
      fieldName: {
        type: String,
        required: true,
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      maxNumber: {
        type: Number,
        default: 1,
      },
      allowedExtensions: {
        type: Array,
        default: () => [], // empty means allow any
      },
    },
    data: () => ({
      errorDialog: null,
      errorText: '',
    }),
    computed: {
      acceptType () {
        return this.allowedExtensions.length > 0
          ? this.allowedExtensions.map(ext => `.${ext}`).join(',')
          : '*/*' // Accept any type
      },
      extensionRule () {
        return this.allowedExtensions.length > 0
          ? `ext:${this.allowedExtensions.join(',')}`
          : '' // No VeeValidate extension rule
      },
    },
    watch: {
      value: {
        handler (newValue) {
          if (!newValue) {
            this.$refs.file.value = ''
          }
        },
        deep: true,
      },
    },
    methods: {
      launchFilePicker () {
        this.$refs.file.click()
      },
      onFileChange (fieldName, files) {
        if (files.length <= 0) return

        if (files.length > this.maxNumber) {
          this.errorDialog = true
          this.errorText = `You can only upload maximum ${this.maxNumber} files`
          
          return
        }

        let formData = new FormData()
        let selectedFiles = []

        for (let i = 0, numFiles = files.length; i < numFiles; i++) {
          const file = files[i]
          const sizeInMb = this.bytesToMB(file.size)

          if (sizeInMb > this.maxSizeInMb) {
            // check whether the size is greater than the size limit
            this.errorDialog = true
            this.errorText = `Your file is too big! Please select a file under ${this.maxSizeInMb}MB`

            return
          }

          const ext = file.name.split('.').pop().toLowerCase()
          if (
            this.allowedExtensions.length > 0 &&
            !this.allowedExtensions.includes(ext)
          ) {
            this.errorDialog = true
            this.errorText = `Only ${this.allowedExtensions.join(', ')} files are allowed`
            return
          }

          // Append file into FormData
          formData.append(`files[${i}]`, file)
          selectedFiles.push(file)
        } 

        // Emit the FormData to the parent component
        this.$emit('input', { formData, selectedFiles })
      },
      bytesToMB (bytes) {
        if (bytes === 0) return 'n/a'

        return (bytes / (1024 ** 2)).toFixed(1)
      },    
    },
  }
</script> 
